import { createAction, props } from '@ngrx/store';

export enum CompanyUsersActions {
  CompanyLoggedUserRequested = '[Company Users] Logged User Requested',
  CompanyLoggedUserLoaded = '[Company Users] Logged User Loaded',
  CompanyLoggedUserError = '[Company Users] Logged User Error',
}

export const CompanyLoggedUserRequested = createAction(CompanyUsersActions.CompanyLoggedUserRequested);
export const CompanyLoggedUserLoaded = createAction(CompanyUsersActions.CompanyLoggedUserLoaded,
  props<{ loggedUser: any }>());
export const CompanyLoggedUserError = createAction(CompanyUsersActions.CompanyLoggedUserError);

